<template>
  <v-form @submit.prevent="submit">
    <v-row>
      <v-col>
        <v-text-field v-model="form.portNumber" label="Anschlusskennung" />
      </v-col>
      <v-col>
        <v-text-field v-model="form.customerNumber" label="Kundennummer" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field v-model="form.accessNumber" label="Zugangsnummer" />
      </v-col>
      <v-col>
        <v-text-field v-model="form.password" label="Kennwort" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-end">
        <v-btn :loading="loading" type="submit" color="primary">
          speichern
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
   props: {
      formData: {
         type: Object,
         required: true
      },
      loading: {
         type: Boolean,
         default:
            false
      }
   },
   data: function () {
      return {
         form: this.formData
      }
   },
   methods: {
      submit () {
         this.$emit('submit', this.form)
      }
   }
}
</script>

<style>

</style>
